module.exports = __webpack_public_path__ + "img/back_1.cce00093.jpg";